import { render, staticRenderFns } from "./FriendCreate.vue?vue&type=template&id=c4d866d2&scoped=true&"
import script from "./FriendCreate.vue?vue&type=script&lang=js&"
export * from "./FriendCreate.vue?vue&type=script&lang=js&"
import style0 from "./FriendCreate.vue?vue&type=style&index=0&id=c4d866d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4d866d2",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTimePicker } from 'vuetify/lib/components/VTimePicker';
installComponents(component, {VAutocomplete,VBtn,VDatePicker,VDialog,VSpacer,VTimePicker})


/* hot reload */
if (module.hot) {
  var api = require("D:\\other\\DaMou-Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4d866d2')) {
      api.createRecord('c4d866d2', component.options)
    } else {
      api.reload('c4d866d2', component.options)
    }
    module.hot.accept("./FriendCreate.vue?vue&type=template&id=c4d866d2&scoped=true&", function () {
      api.rerender('c4d866d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/好友相關/FriendCreate.vue"
export default component.exports